import { Divider, Grid, Select, Text, TextInput } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form/lib/use-form';
import { useEffect, useState } from 'react';
import { cities, provinces } from '../../../../data/province-city.array';
import { Cities } from '../../../../type/province-city.types';
import { UpdateMerchantOnboardingFormValues } from '../../../../type/update-merchant-onboarding-form-values.types';
import PhoneCountryCodeIcon from '../../../icons/phone-country-code-icon.component';

interface RegisteredContactInfoUpdateProps {
  form: UseFormReturnType<UpdateMerchantOnboardingFormValues>;
}
function RegisteredContactInfoUpdate(props: RegisteredContactInfoUpdateProps) {
  const { form } = props;
  const [newProvinces, setNewProvinces] = useState(provinces);
  const [newCities, setNewCities] = useState(cities);

  useEffect(() => {
    if (
      form.values.registeredProvince &&
      !provinces.some((province: { value: string; label: string }) => {
        if (province.value === form.values.registeredProvince) {
          return true;
        }
        return false;
      })
    ) {
      setNewProvinces([
        ...newProvinces,
        {
          key: form.values.registeredProvince,
          value: form.values.registeredProvince,
          label: form.values.registeredProvince,
        },
      ]);
      const newProvince = {
        [form.values.registeredProvince]: [
          {
            key: form.values.registeredCity!,
            value: form.values.registeredCity!,
            label: form.values.registeredCity!,
          },
        ],
      };
      const newCities: Cities = {
        ...cities,
        ...newProvince,
      };
      setNewCities(newCities);
    } else if (
      form.values.registeredProvince &&
      !cities[form.values.registeredProvince].some(
        (city: { value: string; label: string }) => {
          if (city.value === form.values.registeredCity) {
            return true;
          }
          return false;
        }
      )
    ) {
      setNewCities({
        ...newCities,
        [form.values.registeredProvince]: [
          ...newCities[form.values.registeredProvince],
          {
            key: form.values.registeredCity!,
            value: form.values.registeredCity!,
            label: form.values.registeredCity!,
          },
        ],
      });
    }
  }, []);

  const label = {
    registeredContactNumber: 'Registered contact number',
    registeredBldgNameNo: 'Registered building name and number',
    registeredStreetAddress: 'Registered street address',
    registeredBarangay: 'Registered barangay',
    registeredCity: 'Registered city',
    registeredProvince: 'Registered province',
    registeredPostalCode: 'Registered postal code',
  };
  const placeHolder = {
    registeredBldgNameNo: 'Building name and number',
    registeredStreetAddress: 'Street address',
    registeredBarangay: 'Barangay',
    registeredCity: 'City',
    registeredProvince: 'Province',
    registeredPostalCode: 'Postal code',
  };
  return (
    <>
      <Grid data-cy='registeredContactInfo'>
        <Grid.Col>
          <Text size='xl' weight={700}>
            Registered Contact Information
          </Text>
        </Grid.Col>

        <Grid.Col>
          <TextInput
            data-cy='contactNumber'
            label={label.registeredContactNumber}
            icon={<PhoneCountryCodeIcon />}
            iconWidth={48}
            value={form.values.registeredContactNumber}
            onChange={(event) => {
              form.setFieldValue(
                'registeredContactNumber',
                event.currentTarget.value
              );
            }}
            error={form.errors.registeredContactNumber}
          />
        </Grid.Col>
        <Grid.Col>
          <TextInput
            data-cy='bldgNameNo'
            placeholder={placeHolder.registeredBldgNameNo}
            label={label.registeredBldgNameNo}
            value={form.values.registeredBldgNameNo}
            onChange={(event) => {
              form.setFieldValue(
                'registeredBldgNameNo',
                event.currentTarget.value
              );
            }}
            error={form.errors.registeredBldgNameNo}
          />
        </Grid.Col>
        <Grid.Col>
          <TextInput
            data-cy='streetAddress'
            placeholder={placeHolder.registeredStreetAddress}
            label={label.registeredStreetAddress}
            value={form.values.registeredStreetAddress}
            onChange={(event) => {
              form.setFieldValue(
                'registeredStreetAddress',
                event.currentTarget.value
              );
            }}
            error={form.errors.registeredStreetAddress}
          />
        </Grid.Col>

        <Grid.Col xs={12} sm={6}>
          <Select
            data-cy='province'
            label={label.registeredProvince}
            placeholder={placeHolder.registeredProvince}
            data={newProvinces}
            value={form.values.registeredProvince}
            onChange={(value: string) => {
              form.setFieldValue('registeredProvince', value);
              form.setFieldValue('registeredCity', '');
            }}
            searchable
            nothingFound='No options'
            error={form.errors.registeredProvince}
          />
        </Grid.Col>
        <Grid.Col xs={12} sm={6}>
          <Select
            data-cy='city'
            label={label.registeredCity}
            placeholder={placeHolder.registeredCity}
            data={
              form.values.registeredProvince &&
              form.values.registeredProvince.length > 0 &&
              Object.keys(newCities).includes(form.values.registeredProvince)
                ? newCities[form.values.registeredProvince]
                : []
            }
            disabled={form.values.registeredProvince === ''}
            searchable
            value={form.values.registeredCity}
            onChange={(value: string) => {
              form.setFieldValue('registeredCity', value);
            }}
            error={form.errors.registeredCity}
          />
        </Grid.Col>
        <Grid.Col xs={12} md={6}>
          <TextInput
            data-cy='barangay'
            placeholder={placeHolder.registeredBarangay}
            label={label.registeredBarangay}
            value={form.values.registeredBarangay}
            onChange={(event) => {
              form.setFieldValue(
                'registeredBarangay',
                event.currentTarget.value
              );
            }}
            error={form.errors.registeredBarangay}
          />
        </Grid.Col>
        <Grid.Col xs={12} md={6}>
          <TextInput
            data-cy='postalCode'
            placeholder={placeHolder.registeredPostalCode}
            label={label.registeredPostalCode}
            value={form.values.registeredPostalCode}
            onChange={(event) => {
              form.setFieldValue(
                'registeredPostalCode',
                event.currentTarget.value
              );
            }}
            error={form.errors.registeredPostalCode}
          />
        </Grid.Col>
        <Grid.Col>
          <Divider my='md' />
        </Grid.Col>
      </Grid>
    </>
  );
}

export default RegisteredContactInfoUpdate;
